import React, { createContext, useContext, useState } from 'react';

const CarrierContext = createContext();

export const CarrierProvider = ({ children }) => {
  const [carrierId, setCarrierId] = useState('interfreight');

  return (
    <CarrierContext.Provider value={{ carrierId, setCarrierId }}>
      {children}
    </CarrierContext.Provider>
  );
};

export const useCarrier = () => useContext(CarrierContext);
